export default "__VITE_ASSET__Da9dDNpY__"